<template>
  <div class="sectiontitle">
    <div class="inner">
      <component
        :is="isH1 ? 'h1' : 'h2'"
        class="title"
      >
        {{ title }}
        <span
          v-if="note"
          class="note"
        >
          {{ note }}
        </span>
        <template v-if="shareTitle && shareCategory">
          <div class="sub">
            <span
              v-if="leftText"
              class="text"
            >
              {{ leftText }}
            </span>
            <span
              v-if="rightText"
              class="text time"
            >
              {{ rightText }}
            </span>
            <ShareButton
              :title="shareTitle"
              :category="shareCategory"
            />
          </div>
        </template>
        <template v-else>
          <span
            v-if="leftText"
            class="text"
          >
            {{ leftText }}
          </span>
          <span
            v-if="rightText"
            class="text time"
          >
            {{ rightText }}
          </span>
        </template>
      </component>
      <div
        v-if="buttonLink"
        class="button"
      >
        <MoreButton
          :text="buttonText"
          :direction="buttonDir"
          :col="buttonCol"
          :link="buttonLink"
        />
      </div>
      <div
        v-if="buttonIcon"
        class="button"
      >
        <IconButton
          :text="buttonText"
          :icon="buttonIcon"
        />
      </div>
      <div
        v-if="placeholder"
        class="search"
      >
        <form class="form">
          <label class="search">
            <input
              class="input"
              :placeholder="placeholder"
              type="text"
            >
            <button class="submit">
              <img
                src="https://gvs.weathernews.jp/onebox/img/common/icon_search.svg"
                width="25"
                height="25"
                alt=""
                loading="lazy"
              >
            </button>
          </label>
        </form>
      </div>
    </div>
    <p
      v-if="text"
      class="text"
    >
      {{ text }}
    </p>
  </div>
</template>

<script setup>
import MoreButton from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/MoreButton.vue'
import IconButton from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/IconButton.vue'

defineProps({
  title: {
    type: String,
    default: '',
    required: true
  },
  note: {
    type: String,
    default: '',
    required: false
  },
  buttonText: {
    type: String,
    default: 'もっと見る',
    required: false
  },
  buttonDir: {
    type: String,
    default: 'left',
    required: false
  },
  buttonCol: {
    type: String,
    default: 'white',
    required: false
  },
  buttonLink: {
    type: String,
    default: '',
    required: false
  },
  text: {
    type: String,
    default: '',
    required: false
  },
  leftText: {
    type: String,
    default: '',
    required: false
  },
  rightText: {
    type: String,
    default: '',
    required: false
  },
  buttonIcon: {
    type: String,
    default: '',
    required: false
  },
  shareTitle: {
    type: String,
    default: '',
    required: false
  },
  shareCategory: {
    type: String,
    default: '',
    required: false
  },
  placeholder: {
    type: String,
    default: '',
    required: false
  },
  isH1: {
    type: Boolean,
    default: false,
    required: false
  }
})
</script>

<style lang="scss" scoped>
.sectiontitle {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .inner {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .title {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: baseline;
    flex: 1;
    gap: 5px;
    color: #101010;
    font-size: 18px;
    font-weight: bold;
    line-height: 20px;
    &:has(+ .button) {
      overflow-x: scroll;
      overflow-y: hidden;
      white-space: nowrap;
      padding-top: 6px;
      margin-right: 10px;
    }
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 100vmax;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 100vmax;
      background: #d4dcde;
    }
    .sub {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-end;
      flex-wrap: wrap;
      gap: 5px;
      line-height: 100%;
      &:has(.share) {
        width: 100%;
      }
    }
  }
  .note {
    color: #ccc;
    font-size: 12px;
    line-height: 12px;
  }
  .button {
    position: relative;
    display: flex;
    justify-content: flex-end;
    // &::after {
    //   position: absolute;
    //   left: -20px;
    //   top: 0;
    //   width: 20px;
    //   height: 100%;
    //   background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 80%, rgba(255,255,255,1) 100%);
    //   content: '';
    //   z-index: 10;
    // }
  }
  .text {
    color: #101010;
    font-size: 14px;
    line-height: 14px;
    text-align: right;
    white-space: nowrap;
  }
  .search {
    position: relative;
    .input {
      max-width: 130px;
      padding: 5px 35px 5px 10px;
      background-color: #fff;
      border: solid 1px #c0c0c0;
      border-radius: 66px;
      font-size: 15px;
      line-height: 1.5em;
    }
    .submit {
      position: absolute;
      top: -3px;
      right: 10px;
    }
  }
}
main {
  @media screen and (min-width: 830px) {
    .sectiontitle {
      flex-direction: row;
      gap: 0;
      align-items: center;
      justify-content: space-between;
      .title {
        flex-direction: row;
        font-size: 22px;
        line-height: 22px;
        white-space: wrap;
        overflow-x: unset;
        &:has(.text) {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
        }
        &::after {
          display: none;
        }
      }
      .text {
        font-weight: 600;
      }
    }
  }
}
</style>
